<script lang="ts">
  import { onMount } from "svelte"
  import { createPopper } from "@popperjs/core"

  let props = $props()
  let flywheel_entry: FlywheelEntryType = props.flywheel_entry

  let popoverShow = $state(false)

  let popoverRef

  function togglePopover(target) {
    if (popoverShow) {
      popoverShow = false
    } else {
      popoverShow = true
      createPopper(target, popoverRef, {
        placement: "bottom",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -14]
            }
          }
        ]
      })
    }
  }
</script>

<button
  class="border border-blue-50 shadow flex justify-center items-center px-6 py-4 text-base text-center italic rounded text-gray-600 h-36 w-56 bg-indigo-100 overflow-hidden"
  onclick={(e) => togglePopover(e.target)}
  type="button"
>
  {flywheel_entry.title}
</button>
<div
  bind:this={popoverRef}
  class="bg-blue-200 border-0 mr-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words rounded-lg {popoverShow
    ? 'block'
    : 'hidden'}"
>
  <div>
    <div
      class="bg-blue-200 text-white opacity-75 font-semibold p-3 mb-0 border-b border-solid border-blue-100 rounded-lg ProseMirror"
    >
      {#if flywheel_entry.description?.length > 0}
        {@html flywheel_entry.description}
      {:else}
        <span class="italic">No description</span>
      {/if}
    </div>
  </div>
</div>
